export enum SelectVersion {
  DEFAULT = 'default',
  SINGLE_SELECT = 'single-select',
  MULTI_SELECT = 'multi-select',
  COLOR_SELECT = 'color-select',
  FONT_SELECT = 'font-select',
}

export interface SelectOption {
  value: string | number;
  text: string;
  'sub-text'?: string;
  hsp?: boolean;
  visual?: string;
  font?: string;
  selected?: boolean;
}

export interface OptGroup {
  value?: string | number | null;
  label?: string | null;
}

/**
 * Action buttons for the print option, names are used for the event names in file src/components/accordion/fg-accordion-title.ts.
 * Please do not change the names of the enum values.
 */
export enum ActionButton {
  EDIT = 'edit',
  DELETE = 'delete',
}
